import { Tooltip } from "react-tooltip";
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';
import FavoriteIcon from '@mui/icons-material/Favorite';
import ModeCommentOutlinedIcon from '@mui/icons-material/ModeCommentRounded';
import SendIcon from '@mui/icons-material/SendRounded';
import { useContext, useMemo, useState } from "react";
import { FormContext } from "../../../context/FormContext";
import { useNavigate } from "react-router-dom";
import { doc, setDoc, serverTimestamp, collection, addDoc } from "firebase/firestore";
import { calculateInvoice } from "../../../utils/calculateInvoice";
import { getToken } from 'firebase/app-check';
import { appCheck } from '../../../firebase';

function InvoiceForm() {
  const { formData, updateForm } = useContext(FormContext);

  console.log(formData);
  

  const navigate = useNavigate();

  // Keep as strings for natural typing; seed from context if present
  const [local, setLocal] = useState({
    fullName: formData.fullName?.toString() ?? "",
    igHandle: formData.igHandle?.toString() ?? "",
    paymentMethod: formData.paymentMethod?.toString() ?? "",
    paymentLink: formData.paymentLink?.toString() ?? "",
    email: formData.email?.toString() ?? "",
  });

  const [handleError, setHandleError] = useState("");

  // Handlers (trim left spaces, keep UX simple)
  const onName = (e) => {
    const v = e.target.value.replace(/^\s+/, "");
    setLocal(p => ({ ...p, fullName: v }));
    updateForm?.({ fullName: v });
  };

  const onHandle = (e) => {
    let v = e.target.value.replace(/\s+/g, "");
    if (v.length > 1) v = v[0] === "@" ? "@" + v.slice(1).replace(/^@+/, "") : v.replace(/^@{2,}/, "@");
    setLocal(p => ({ ...p, igHandle: v }));
    updateForm?.({ igHandle: v });
    if (handleError) setHandleError("");        // ⬅️ clear error on change
  };

  const onMethod = (e) => {
    const v = e.target.value.trimStart();
    setLocal(p => ({ ...p, paymentMethod: v }));
    updateForm?.({ paymentMethod: v });
  };

  const onLink = (e) => {
    const v = e.target.value.trim();
    setLocal(p => ({ ...p, paymentLink: v }));
    updateForm?.({ paymentLink: v });
  };

  const onEmail = (e) => {
    const v = e.target.value.trim();
    setLocal(p => ({ ...p, email: v }));
    updateForm?.({ email: v });
  };

  const generate = async () => {
    const btn = document.querySelector('#generateButton');
    btn.disabled = true; btn.innerHTML = 'Generating...'; btn.style.opacity = '0.75';
    const reset = () => { btn.disabled = false; btn.innerHTML = 'Generate Your Invoice'; btn.style.opacity = '1'; };

    try {
      const {
        fullName, igHandle, paymentMethod, paymentLink, email,
        activeMins, followerCount, minsPerPost, postCount, valueType
      } = formData || {};

      if (!fullName || !igHandle ) {
        alert("Please complete all fields.");
        return reset();
      }

      const content_revenue = followerCount * 3 * 48 / 1000 * 19.80;
      const doomscroll_value = activeMins / 60 * 1460 * 0.34;
      const creative_labour = postCount * 1.626 * minsPerPost * valueType / 60;
      const wellbeing = 6000;

      if (content_revenue > 1807660800) return reset();
      if (doomscroll_value > 12000) return reset();
      if (creative_labour > 400000000) return reset();

      const result = content_revenue + doomscroll_value + creative_labour + wellbeing;

      const { token } = await getToken(appCheck, /* forceRefresh */ false);

      const res = await fetch('/api/save-invoice', {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'X-Firebase-AppCheck': token
        },
        body: JSON.stringify({
          fullName,
          igHandle,
          email,

          followerCount,
          content_revenue,
          
          activeMins,
          doomscroll_value,
          
          postCount,
          minsPerPost,
          valueType,
          creative_labour,
          
          result
        }),
      });

      // Read body once
      const data = await res.json().catch(() => ({}));

      if (res.status === 201) {
        // ⬅️ store invoiceNumber in global formData so you can use it later
        if (data.invoiceNumber) {
          updateForm?.({ invoiceNumber: data.invoiceNumber });
        }

        navigate('/review');
        return reset();
      }

      if (res.status === 409) {
        setHandleError(`An invoice for this handle exists already...`);
        document.getElementById('igHandle')?.focus();
        return reset();
      }

      // Optional: generic error handling
      console.error('Unexpected response', res.status, data);
      reset();
    } catch (err) {
      console.error(err);
      reset();
    }
  };

  
  const disabled = !(
    formData.activeMins &&
    formData.followerCount &&
    formData.minsPerPost &&
    formData.postCount &&
    formData.valueType &&

    formData.fullName &&
    formData.igHandle
  );


  return (
    <>
      <div className="contents-main">
        <h1 >Your details.</h1>

        <div>
          <div className="" style={{ marginTop: 10 }}>
            <label for="fullname">Your Name <span style={{color: 'rgb(1, 152, 255)'}}>*</span></label>
            <input
              id="fullname"
              name="fullname"
              type="text"
              placeholder="Enter your name"
              min="0"
              value={local.fullName}
              onChange={onName}
              style={{ outline: 'none', border: '1px solid #c7c7c7ff', borderRadius: 6, height: 35, textAlign: 'left', padding: '0 2%', width: '90%' }}
            />

          </div>
          <div className="" style={{ marginTop: 10 }}>
            <label for="igHandle">Instagram Handle <span style={{color: 'rgb(1, 152, 255)'}}>*</span></label>
            <input
              id="igHandle"
              type="text"
              value={local.igHandle}
              onChange={onHandle}
              placeholder="yourhandle"
              style={{ outline: 'none', border: '1px solid #c7c7c7ff', borderRadius: 6, height: 35, textAlign: 'left', padding: '0 2%', width: '90%' }}
            />
            {handleError && (
              <p id="igHandle-error" role="alert" style={{ fontSize: 12,color:'#d32f2f', marginTop:4 }}>
                {handleError}
              </p>
            )}

          </div>
          <div className="" style={{ marginTop: 10 }}>
            <label for="paymentMethod">Payment Method</label>
            <select
              id="paymentMethod"
              value={local.paymentMethod}
              onChange={onMethod}
              style={{
                outline: "none",
                marginTop: '10',
                border: "1px solid #c7c7c7ff",
                borderRadius: 8,
                height: 35,
                textAlign: "left",
                width: "94%",
                padding: "0 2%",
                background: "white",
              }}
            >
              <option value="">Select a method</option>
              <option value="PayPal">PayPal</option>
              <option value="Venmo">Venmo</option>
            </select>

          </div>
          <div className="" style={{ marginTop: 10 }}>
            <label for="accNumber">Payment Username</label>
            <input
              id="accNumber"
              name="accNumber"
              type="string"
              placeholder="Enter your payment username"
              min="0"
              value={local.paymentLink}
              onChange={onLink}
              style={{ outline: 'none', border: '1px solid #c7c7c7ff', borderRadius: 6, height: 35, textAlign: 'left', padding: '0 2%', width: '90%' }}
            />

          </div>

          <div className="" style={{ marginTop: 10 }}>
            <label for="email">Email</label>
            <input
              id="email"
              name="email"
              type="email"
              value={local.email}
              placeholder="Enter your email"
              onChange={onEmail}
              style={{ outline: 'none', border: '1px solid #c7c7c7ff', borderRadius: 6, height: 35, textAlign: 'left', padding: '0 2%', width: '90%' }}
            />

          </div>
        </div>
      </div>

      <div className="contents-footer" style={{padding: 0}}>
        { disabled ?
          <p className="footer-label">Complete the form to continue...</p>
          :
          <button id="generateButton" style={{width: '100%', height: '100%', borderRadius: 0, fontSize: 16}} onClick={ generate }>Generate Your Invoice</button>
        }
        
      </div>
    </>
  );

}
export default InvoiceForm;
